import { useEffect, useMemo, useRef, useState } from "react";
import { Canvas, useFrame, useLoader, useThree } from "@react-three/fiber";
import * as THREE from "three";
import Großer from "../../../../../asset/großer-planet-unten.png";
import Rechts from "../../../../../asset/planet-rechts.png";
import Rings from "../../../../../asset/planet-links.png";
import ufo from "../../../../../asset/ufo.png";
import { Text } from "@react-three/drei";
import { useDispatch } from "react-redux";

import { a, useSpring } from "@react-spring/three";
import { useTranslation } from "react-i18next";
type LoadingPlanetProps = {
  getFadeOut: (fade: boolean) => void;
};
const LoadingPlanet = ({ getFadeOut }: LoadingPlanetProps) => {
  const { viewport } = useThree();
  const GroßerTexture = useLoader(THREE.TextureLoader, Großer);
  const RechtsTexture = useLoader(THREE.TextureLoader, Rechts);
  const RingsTexture = useLoader(THREE.TextureLoader, Rings);
  const ufoTexture = useLoader(THREE.TextureLoader, ufo);
  const rechtsRef = useRef<any>(null);
  const großerRef = useRef<any>(null);
  const ringsRef = useRef<any>(null);
  const ufoRef = useRef<any>(null);
  const dispatch = useDispatch();
  const textRef1 = useRef<any>(null);
  const textRef = useRef<any>(null);
  const [showText, setShowText] = useState(false);
  const [showUfo, setShowUfo] = useState(false);
    const { t } = useTranslation();
    const viewScale = useMemo(() => {
      // normalize viewport width for scaling
      return Math.min(viewport.width / 15, 1);
    }, [viewport.width]);

  useFrame((state) => {
console.log(viewScale,'viewScale')
    const elapsed = state.clock.getElapsedTime();
    if (großerRef.current && !showText) {
      const posY = großerRef.current.position.y;
      const targetY = 0.7;
      const speed = 0.03;

      if (Math.abs(targetY - posY) < speed) {
        großerRef.current.position.y = targetY;
        if(großerRef.current.position.z !==4){
          setShowText(true);
        }
      } else {
        großerRef.current.position.y += speed;
      }
    }
    if (rechtsRef.current && !showText) {
      const posY = rechtsRef.current.position.y;
      const targetY = -1.25;
      const speed = 0.04;

      if (Math.abs(targetY - posY) < speed) {
        rechtsRef.current.position.y = targetY;
      } else {
        rechtsRef.current.position.y += speed;
      }
    }
    if (ringsRef.current) {
      const posY = ringsRef.current.position.y;
      const targetY = 2;
      const speed = 0.05;

      if (Math.abs(targetY - posY) < speed) {
        ringsRef.current.position.y = targetY;
      } else {
        ringsRef.current.position.y += speed;
      }
    }

    if (textRef.current) {
      setTimeout(() => {
        setShowUfo(true);
      }, 500);
    }
    if (ufoRef.current) {
    
      const posY = ufoRef.current.position.y;
      const targetY = -0.9;
      const speed = 0.03;
      if (Math.abs(targetY - posY) < speed) {
        ufoRef.current.position.y = targetY;
      } else {
        ufoRef.current.position.y += speed;
      }

      if (ufoRef.current.position.y == -0.9) {
        setShowText(false)
        ufoRef.current.position.y = -0.9 + Math.sin(elapsed * 10) * 0.01;
        ufoRef.current.rotation.z = Math.sin(elapsed * 8) * 0.03;
        const großerRefZ = großerRef.current.position.z;
        const targetZ = 4;
        const speed = 0.03;
        if (Math.abs(targetZ - großerRefZ) < speed) {
          großerRef.current.position.z = targetZ;
          rechtsRef.current.position.z = targetZ;
          ringsRef.current.position.z = targetZ;
        } else {
          großerRef.current.position.z += speed;
          rechtsRef.current.position.z += speed;
          ringsRef.current.position.z += speed;
        }
        console.log(großerRef.current.position.z)
        if( großerRef.current.position.z ==4 ){
    
          // setShowText(false)
          const targetY = 4;
          const speed = 0.03;
          if (Math.abs(targetY - posY) < speed) {
            ufoRef.current.position.y = targetY;
          } else {
            ufoRef.current.position.y += speed;
          }
          getFadeOut(true)
        }
      }
    }
  });

  const textSpring = useSpring({
    scale: showText ? 1 : 0.5,
    config: { tension: 80, friction: 20 },
  });

  return (
    <>
       <mesh position={[0, 0, 0]}  >
      {showUfo && (
        <mesh position={[0, -4, 2.3]} ref={ufoRef}>
          <planeGeometry args={[0.5, 0.7, 1]} />
          <meshBasicMaterial
            attach="material"
            map={ufoTexture}
            transparent={true}
          />
        </mesh>
      )}
      <mesh position={[0, -2, 0.65]} ref={großerRef}>
        <planeGeometry args={[14, 9, 10]} />
        <meshBasicMaterial
          attach="material"
          map={GroßerTexture}
          transparent={true}
        />
      </mesh>
      <mesh position={[3.5, -5, 0]} ref={rechtsRef}>
        <planeGeometry args={[5, 4, 1]} />
        <meshBasicMaterial
          attach="material"
          map={RechtsTexture}
          transparent={true}
        />
      </mesh>
      <mesh position={[-5.5, -5, 0]} ref={ringsRef}>
        <planeGeometry args={[3, 3, 1]} />
        <meshBasicMaterial
          attach="material"
          map={RingsTexture}
          transparent={true}
        />
      </mesh>

      {showText && (
        <>
           <mesh position={[0, 0, 0]}   scale={viewScale}>
          <a.group
            scale={textSpring.scale}
            position={[0, 0.5, 1]}
            ref={textRef1}
          >
            <Text fontSize={1} color="white" anchorY="middle">
             {t('KARUNA KOSMOS')} 
            </Text>
          </a.group>
          <a.group
            scale={textSpring.scale}
            position={[0, -0.5, 1]}
            ref={textRef}
          >
            <Text fontSize={0.3} color="white" anchorY="middle">
            {t('universe_for_good')} 
            </Text>
          </a.group>
          </mesh>
        </>
      )}
      </mesh>
    </>
  );
};

export default LoadingPlanet;
